import Swiper, {Navigation, Pagination, Autoplay} from 'swiper'
Swiper.use([Navigation, Pagination, Autoplay]);

export default function sliders() {
  (function($) {
    $(window).on('load', function () {
           // get all sliders, we need to loop them due to different settings + nav
           var swipers = document.querySelectorAll('.reviews-swiper');
           swipers.forEach(function(el,index){
            var closestSection = el.closest('section');
            var controls = closestSection.querySelector('.control');

                // slider settings
                var options = {
                  speed: 500,
                  loop: true,
                    //autoplay: {
                        //delay: 5000,
                        //disableOnInteraction: true,
                    //},
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    },
                    freeMode: true,
                    centeredSlides: true,
                    slidesPerView: 1,
                    spaceBetween: 30,
                    autoHeight: true,
                    on: {
                      slideChange: (swiper) => {
                        let image =
                        swiper.slides[
                        swiper.activeIndex
                        ].querySelector('img[data-src]')
                        if (image) {
                          loadSlideImage(image);
                        }
                      },
                    },

                    breakpoints: {
                      640: {
                        spaceBetween: 80,
                        slidesPerView: 1,
                      },
                      992: {
                        spaceBetween: 150,
                        slidesPerView: 1,
                      },
                      1172: {
                        spaceBetween: 834,
                        slidesPerView: 1,
                      },
                    },
                  };

                // init slider
                new Swiper(el, options);
              });
         })

  })( jQuery );

  (function($) {
    $(window).on('load', function () {
           // get all sliders, we need to loop them due to different settings + nav
           var swipers = document.querySelectorAll('.testimonials-swiper');
           swipers.forEach(function(el,index){
            var closestSection = el.closest('section');
            var controls = closestSection.querySelector('.control');

                 // slider settings
                 var options = {
                  loop: true,
                  autoHeight: false,
                    //centeredSlides: true,
                   // autoplay: {
                        //delay: 1800,
                       // disableOnInteraction: true,
                    //},
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    },
                    freeMode: true,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    on: {
                      slideChange: (swiper) => {
                        let image =
                        swiper.slides[
                        swiper.activeIndex
                        ].querySelector('img[data-src]')
                        if (image) {
                          loadSlideImage(image);
                        }
                      },
                    },

                    breakpoints: {
                      640: {
                        spaceBetween: 16,
                        slidesPerView: 2,
                      },
                      992: {
                        spaceBetween: 16,
                        slidesPerView: 3,
                        pagination: false,
                        loop: false,
                      },
                      1172: {
                        spaceBetween: 16,
                        slidesPerView: 3,
                        pagination: false,
                        loop: false,
                      },
                    },
                  };

                // init slider
                new Swiper(el, options);
              });
         })

  })( jQuery );

}


function loadSlideImage(image) {
  let src = image.getAttribute('[data-src]')
  let sourceSet = image.parentNode.querySelectorAll('[data-srcset]')
  if (sourceSet.length > 0) {
    for (let i = 0; i < sourceSet.length; i++) {
      sourceSet[i].srcset = sourceSet[i].getAttribute('data-srcset')
    }
  }
  if ('img' === image.tagName.toLowerCase()) {
    if (src) {
      image.src = src
    }
  } else {
    image.style.backgroundImage = "url('" + src + "')"
  }
}